import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-577a3184"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: ""
};
const _hoisted_2 = {
  class: "dialog-footer"
};
import { useVModel, useDebounceFn } from '@vueuse/core';
import { ref, watch, onMounted } from 'vue';
import { ElMessage } from 'element-plus';
// import { addAppIdAsync, getTenantNameListAsync } from '@/api/appid'
import { addAppIdAsync } from '@/api/appid';
import { getTenantAndClinicPage } from '@/api/tenant';
export default {
  __name: 'appidDialog',
  props: {
    // 回显数据
    model: {
      type: Object,
      default: null
    },
    // dialog显示
    modelValue: {
      type: Boolean,
      required: true
    }
  },
  emits: ['update:modelValue', 'refreshData', 'clearModel'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;

    // 表单数据
    const formData = ref({
      // tenantName: '', // 租户名称
      // tenantId: '', // 租户id
      tenant: [],
      appId: '',
      // appid
      appSecret: '',
      // 应用密钥
      remark: '',
      appType: 1
    });

    // 清空表单数据
    const resetForm = () => {
      formData.value = {
        tenant: [],
        appId: '',
        // appid
        appSecret: '',
        // 应用密钥
        remark: '',
        appType: 1
      };
    };
    const cascaderProps = ref({
      value: 'id',
      label: 'name',
      children: 'clinics',
      checkStrictly: true
    });
    const tenantData = ref([]);
    const _getAllTenantData = async () => {
      const res = await getTenantAndClinicPage({
        pageSize: 200,
        isParent: 1
      });
      tenantData.value = res.records;
    };
    onMounted(() => {
      _getAllTenantData();
    });

    // const id = ref(null)
    // 自动补全获取租户名称
    // const getTenantNameList = async (value, cb) => {
    //   const tenantNameList = await getTenantNameListAsync({
    //     pageSize: 200,
    //     currentPage: 1,
    //     isParent: 1,
    //     keyword: value
    //   })
    //   if (tenantNameList.records) {
    //     const list = []
    //     tenantNameList.records.forEach((item) => {
    //       list.push({ value: item.name, id: item.id })
    //     })
    //     cb(list)
    //   } else {
    //     const list = []
    //     cb(list)
    //   }
    //   // console.log(tenantNameList)
    // }
    // const handleSelect = (e) => {
    //   formData.value.tenantId = e.id
    // }
    // 舰艇是否传过来数据
    watch(() => props.model, val => {
      if (val) {
        const tenantId = val.tenantId ? val.tenantId | 0 : '';
        const clinicId = val.clinicId ? val.clinicId | 0 : '';
        const tenant = clinicId ? [tenantId, clinicId] : [tenantId];
        formData.value = {
          ...val,
          tenant
        };
      } else {
        resetForm();
      }
    }, {
      deep: true,
      immediate: true
    });
    // 给父组件派发事件
    const emits = __emit;

    // dialog显示
    const isVisible = useVModel(props);

    // 表单校验
    const rules = ref({
      tenant: [{
        required: true,
        message: '不能为空',
        trigger: 'blur'
      }],
      // tenantId: [{ required: true, message: '不能为空', trigger: 'blur' }],
      appId: [{
        required: true,
        message: '不能为空',
        trigger: 'blur'
      }],
      appSecret: [{
        required: true,
        message: '不能为空',
        trigger: 'blur'
      }]
    });

    // 表单元素
    const formEl = ref(null);
    /**
     * 新增appid
     */
    const addNewsGmHandler = useDebounceFn(async () => {
      if (!formEl.value) return;
      await formEl.value.validate(async (valid, fields) => {
        if (valid) {
          var _tenant$clinics;
          console.log(formData.value);
          const tenant = tenantData.value.find(item => item.id === formData.value.tenant[0]);
          console.log(tenant);
          const clinic = (_tenant$clinics = tenant.clinics) === null || _tenant$clinics === void 0 ? void 0 : _tenant$clinics.find(item => item.id === formData.value.tenant[1]);
          const tenantId = tenant.id;
          const tenantName = tenant.name;
          const clinicId = clinic === null || clinic === void 0 ? void 0 : clinic.id;
          const clinicName = clinic === null || clinic === void 0 ? void 0 : clinic.name;
          try {
            if (!props.model) {
              await addAppIdAsync({
                ...formData.value,
                tenantId,
                tenantName,
                clinicId,
                clinicName
              });
            } else {
              await addAppIdAsync({
                ...formData.value,
                tenantId,
                tenantName,
                clinicId,
                clinicName
              });
            }
            emits('refreshData');
            ElMessage({
              type: 'success',
              message: props.model ? '修改成功' : '添加成功'
            });
          } catch (error) {
            // console.log(error)
          } finally {
            isVisible.value = false;
          }
        } else {
          ElMessage({
            type: 'error',
            message: '验证失败'
          });
        }
      });
    }, 300);
    const closed = () => {
      formEl.value.resetFields();
      resetForm();
      if (props.model) {
        emits('clearModel');
      }
    };
    return (_ctx, _cache) => {
      const _component_el_cascader = _resolveComponent("el-cascader");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        modelValue: _unref(isVisible),
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => _isRef(isVisible) ? isVisible.value = $event : null),
        title: __props.model ? '修改appid' : '新增appid',
        width: "50%",
        onClosed: closed,
        class: "dialog-class",
        "close-on-click-modal": false
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
          onClick: _cache[7] || (_cache[7] = $event => isVisible.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: _unref(addNewsGmHandler)
        }, {
          default: _withCtx(() => [_createTextVNode(" 确认 ")]),
          _: 1
        }, 8, ["onClick"])])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          "label-width": "150px",
          model: formData.value,
          rules: rules.value,
          style: {
            "max-width": "90%"
          },
          ref_key: "formEl",
          ref: formEl
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "租户",
            prop: "tenant"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_cascader, {
              modelValue: formData.value.tenant,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formData.value.tenant = $event),
              options: tenantData.value,
              clearable: "",
              props: cascaderProps.value,
              "show-all-levels": false,
              filterable: "",
              style: {
                "width": "40%"
              }
            }, null, 8, ["modelValue", "options", "props"])]),
            _: 1
          }), _withDirectives(_createVNode(_component_el_form_item, {
            label: "租户id",
            prop: "tenantId"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: formData.value.tenantId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => formData.value.tenantId = $event),
              placeholder: "租户id",
              disabled: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }, 512), [[_vShow, __props.model]]), _withDirectives(_createVNode(_component_el_form_item, {
            label: "诊所id",
            prop: "tenantId"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: formData.value.clinicId,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => formData.value.clinicId = $event),
              placeholder: "诊所id",
              disabled: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }, 512), [[_vShow, __props.model]]), _createVNode(_component_el_form_item, {
            label: "appId",
            prop: "appId"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: formData.value.appId,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => formData.value.appId = $event),
              placeholder: "请输入appId"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "应用密钥",
            prop: "appSecret"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: formData.value.appSecret,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => formData.value.appSecret = $event),
              placeholder: "请输入应用密钥"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "密钥类型",
            prop: "appType"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: formData.value.appType,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => formData.value.appType = $event)
            }, {
              default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList([{
                label: '患者小程序密钥',
                value: 1
              }, {
                label: '咨询师小程序密钥',
                value: 2
              }, {
                label: '医生小程序密钥',
                value: 3
              }], item => {
                return _createVNode(_component_el_radio, {
                  key: item.value,
                  label: item.value
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1)]),
                  _: 2
                }, 1032, ["label"]);
              }), 64))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "描述",
            prop: "appSecret"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              type: "textarea",
              modelValue: formData.value.remark,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => formData.value.remark = $event),
              placeholder: "请输入appId描述"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["modelValue", "title"])]);
    };
  }
};